import axios from 'axios'
import { CADASTRAR_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarEncomenda (encomenda) {
  const url = `${URL}/encomendas/cadastrar`;
  return dispatch => axios.post(url, encomenda, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_ENCOMENDA,
        payload: response
      })
  );
}
